import { api, apiWithoutContentType } from './client';

// Admin Daily Schedule > Create Lesson Plan (backend routes/lessonPlanRoutes.js).

// Children of a Balagruha with their latest Syllabus Tracker session per
// topic and latest GCompris game.
export const getLessonPlanChildrenProgress = async (balagruhaId) => {
  const response = await api.get('/api/lesson-plans/children-progress', { params: { balagruhaId } });
  return response.data;
};

// Published scene / story / poem / Life Skills course content, by One-on-One column.
export const getLessonPlanCatalog = async () => {
  const response = await api.get('/api/lesson-plans/catalog');
  return response.data;
};

// The last two visits to the Balagruha before `before` (YYYY-MM-DD).
export const getLessonPlanPreviousVisits = async (balagruhaId, before) => {
  const response = await api.get('/api/lesson-plans/previous-visits', { params: { balagruhaId, before } });
  return response.data;
};

// e.g. { balagruhaId, date, status: 'draft' } to find a saved draft.
export const findLessonPlans = async (params) => {
  const response = await api.get('/api/lesson-plans', { params });
  return response.data;
};

export const getLessonPlan = async (planId) => {
  const response = await api.get(`/api/lesson-plans/${planId}`);
  return response.data;
};

// status 'draft' saves the plan only; 'scheduled' also creates the coaches' visits.
export const createLessonPlan = async (data) => {
  const response = await api.post('/api/lesson-plans', data);
  return response.data;
};

export const updateLessonPlan = async (planId, data) => {
  const response = await api.put(`/api/lesson-plans/${planId}`, data);
  return response.data;
};

// Records the share; the response carries `shareText` to send to the coaches.
export const shareLessonPlan = async (planId) => {
  const response = await api.post(`/api/lesson-plans/${planId}/share`);
  return response.data;
};

// Same client and longer timeout as the syllabus practice uploads.
const ATTACHMENT_UPLOAD_TIMEOUT_MS = 5 * 60 * 1000;

export const uploadLessonPlanAttachment = async (planId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiWithoutContentType.post(`/api/lesson-plans/${planId}/attachments`, formData, {
    timeout: ATTACHMENT_UPLOAD_TIMEOUT_MS,
  });
  return response.data;
};

export const getLessonPlanAttachmentUrl = async (planId, attachmentId) => {
  const response = await api.get(`/api/lesson-plans/${planId}/attachments/${attachmentId}/url`);
  return response.data;
};

export const deleteLessonPlanAttachment = async (planId, attachmentId) => {
  const response = await api.delete(`/api/lesson-plans/${planId}/attachments/${attachmentId}`);
  return response.data;
};
